"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const store_1 = require("../../../store/store");
const react_select_1 = __importDefault(require("react-select"));
const appSlice_1 = require("../../../store/slices/appSlice");
const bookingSlice_1 = require("../../../store/slices/bookingSlice");
const utils_1 = require("../../../helpers/utils");
const usePrevious_1 = __importDefault(require("../../../hooks/usePrevious"));
const TapChoices = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const userDonationTypes = (0, store_1.useAppSelector)((state) => (0, appSlice_1.getUserDonationTypes)(state));
    const userCanMakeAppointment = (0, store_1.useAppSelector)((state) => (0, bookingSlice_1.canUserMakeAppointment)(state));
    const { currentBooking } = (0, store_1.useAppSelector)((state) => state.booking);
    const [locationOptions, setLocationOptions] = (0, react_1.useState)(undefined);
    const [calendarOptions, setCalendarOptions] = (0, react_1.useState)(undefined);
    const [noCalendarAvailable, setNoCalendarAvailable] = (0, react_1.useState)(false);
    const prevBooking = (0, usePrevious_1.default)(currentBooking);
    const fetchLocationOptions = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        setLocationOptions(undefined);
        try {
            const response = yield axios.post('api/booking/get-locations', {
                donationType: currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.donationType,
            });
            if (_.size(response.data.data) === 1) {
                dispatch((0, bookingSlice_1.updateCurrentBooking)({
                    prop: 'locationId',
                    value: _.get(response.data, 'data.[0].id'),
                }));
            }
            setLocationOptions(response.data.data);
        }
        catch (error) {
            console.error('Failed to fetch location options:', error);
        }
    }), [currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.donationType, dispatch]);
    const fetchCalendarOptions = (0, react_1.useCallback)((changedKey) => __awaiter(void 0, void 0, void 0, function* () {
        setCalendarOptions(undefined);
        setNoCalendarAvailable(false);
        if (_.get(currentBooking, [changedKey])) {
            try {
                const response = yield axios.post('api/booking/get-available-calendars', {
                    donationType: currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.donationType,
                    locationId: _.get(currentBooking, [changedKey]),
                });
                if (_.size(response.data.data) === 1) {
                    dispatch((0, bookingSlice_1.updateCurrentBooking)({
                        prop: 'calendarId',
                        value: _.get(response.data, 'data.[0].id'),
                    }));
                }
                else {
                    setNoCalendarAvailable(_.size(response.data.data) === 0);
                }
                setCalendarOptions(response.data.data);
            }
            catch (error) {
                console.error('Failed to fetch calendar options:', error);
            }
        }
    }), [currentBooking, dispatch]);
    (0, react_1.useEffect)(() => {
        if (_.size(userDonationTypes) === 1 && !currentBooking.donationType) {
            fetchLocationOptions();
            dispatch((0, bookingSlice_1.updateCurrentBooking)({
                prop: 'donationType',
                value: userDonationTypes[0].donationTypeEnum,
            }));
        }
    }, [userDonationTypes, currentBooking, dispatch, fetchLocationOptions]);
    (0, react_1.useEffect)(() => {
        if (prevBooking === undefined) {
            fetchLocationOptions();
            return;
        }
        const changedKey = _.first((0, utils_1.changedKeys)(currentBooking, prevBooking));
        if (changedKey) {
            if (changedKey === 'donationType') {
                fetchLocationOptions();
            }
            else if (changedKey === 'locationId') {
                fetchCalendarOptions(changedKey);
            }
        }
        else if (currentBooking.locationId && currentBooking.calendarId && !calendarOptions) {
            fetchCalendarOptions('locationId');
        }
    }, [currentBooking, prevBooking, calendarOptions, fetchCalendarOptions, fetchLocationOptions]);
    const handleChange = (option) => {
        dispatch((0, bookingSlice_1.updateCurrentBooking)(option));
    };
    const options = userDonationTypes.map((d) => {
        const types = __rest(userCanMakeAppointment, []);
        const isDisabled = !_.flatMap(types).find(({ canBook, donationType }) => donationType === d.donationTypeEnum && canBook === true);
        return Object.assign(Object.assign({}, d), { isDisabled });
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [noCalendarAvailable && (0, jsx_runtime_1.jsx)("p", { children: __.trans('booking.no-available-appointments') }), (0, jsx_runtime_1.jsxs)("div", { id: "tap-choices", className: "rounded shadow py-3 mb-5", children: [_.size(userDonationTypes) > 1 && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { id: "donation-type-label", children: __.trans('booking.tap-label-donation-type') }), (0, jsx_runtime_1.jsx)(react_select_1.default, { classNamePrefix: "react-select", isClearable: _.size(userDonationTypes) > 1, options: options, getOptionValue: (o) => o.donationTypeEnum, getOptionLabel: (o) => o.donationType, onChange: (option) => handleChange({ prop: 'donationType', value: option === null || option === void 0 ? void 0 : option.donationTypeEnum }), value: _.find(userDonationTypes, { donationTypeEnum: currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.donationType }), placeholder: __.trans(_.size(userDonationTypes) === 0
                                    ? 'app.general_loading'
                                    : 'booking.tap-choice-donation-type'), isLoading: _.size(userDonationTypes) === 0, "aria-labelledby": "donation-type-label", isSearchable: false }, `donation_key__${currentBooking.donationType}`)] })), (currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.donationType) && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { id: "location-label", children: __.trans('booking.tap-label-location') }), (0, jsx_runtime_1.jsx)(react_select_1.default, { classNamePrefix: "react-select", isClearable: _.size(locationOptions) > 1, options: locationOptions, getOptionValue: (o) => o.id, getOptionLabel: (o) => o.name, onChange: (option) => handleChange({ prop: 'locationId', value: option === null || option === void 0 ? void 0 : option.id }), value: _.find(locationOptions, { id: currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.locationId }), placeholder: __.trans(_.size(locationOptions) === 0
                                    ? 'app.general_loading'
                                    : 'booking.tap-choice-location'), isLoading: _.size(locationOptions) === 0, "aria-labelledby": "location-label", isSearchable: false }, `location_key__${currentBooking.locationId}`)] })), (currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.locationId) && _.size(calendarOptions) > 1 && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("label", { id: "calender-label", children: __.trans('booking.tap-label-calendar') }), (0, jsx_runtime_1.jsx)(react_select_1.default, { classNamePrefix: "react-select", isClearable: _.size(calendarOptions) > 1, options: calendarOptions, getOptionValue: (o) => o.id, getOptionLabel: (o) => o.name, onChange: (option) => handleChange({ prop: 'calendarId', value: option === null || option === void 0 ? void 0 : option.id }), value: _.find(calendarOptions, { id: currentBooking === null || currentBooking === void 0 ? void 0 : currentBooking.calendarId }), placeholder: __.trans(_.size(calendarOptions) === 0
                                    ? 'app.general_loading'
                                    : 'booking.tap-choice-calendar'), isLoading: _.size(calendarOptions) === 0, "aria-labelledby": "calender-label" }, `calendar_key__${currentBooking.calendarId}`)] }))] })] }));
};
exports.default = TapChoices;
